import { notificationFragment } from 'apollo/fragments';
import { gql } from 'graphql.macro';

export const notificationsTemplate = gql`
    query notifications(
        $onlyUnread: Boolean
        $onlyNotDone: Boolean
        $types: [NotificationType!]
        $category: NotificationCategory
        $limit: Int
        $offset: Int
    ) {
        notifications(
            onlyUnread: $onlyUnread
            onlyNotDone: $onlyNotDone
            types: $types
            category: $category
            limit: $limit
            offset: $offset
        ) {
            ...notificationFields
        }
    }
    ${notificationFragment}
`;

export const unreadNotificationsCountTemplate = gql`
    query unreadNotificationsCount {
        unreadNotificationsCount
    }
`;
